import { render, staticRenderFns } from "./answerMBTI.vue?vue&type=template&id=2469937f&scoped=true&"
import script from "./answerMBTI.vue?vue&type=script&lang=js&"
export * from "./answerMBTI.vue?vue&type=script&lang=js&"
import style0 from "./answerMBTI.vue?vue&type=style&index=0&id=2469937f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2469937f",
  null
  
)

export default component.exports